import AuthorizationHelper from '@auth/services/authorization.helper';

const routes = [
  {
    path: 'superadmin-options',
    name: 'superadmin-options-form',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.superadmin_options],
    },
    component: () =>
      import(
        /* webpackChunkName: "superadmin-options-form" */ '@core/pages/superadmin-options-page.vue'
      ),
  },
  {
    path: 'customer-area-setting',
    name: 'customer-area-setting-form',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.customer_area_setting],
    },
    component: () =>
      import(
        /* webpackChunkName: "customer-area-setting-form" */ '@core/pages/customer-area-setting-page.vue'
      ),
  },

  {
    path: 'center-settings',
    name: 'admin-center-settings',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.center_settings],
    },
    component: () =>
      import(
        /* webpackChunkName: "admin-center-settings" */ '@core/pages/center-settings/center-settings.vue'
      ),
  },
  {
    path: 'payment-config',
    name: 'admin-payment-config',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.center_settings],
    },
    component: () =>
      import(/* webpackChunkName: "admin-payment-config" */ '@core/pages/payment-config-page.vue'),
  },
  {
    path: 'club-settings',
    name: 'admin-club-center-settings',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.center_settings],
    },
    component: () =>
      import(
        /* webpackChunkName: "admin-center-settings" */ '@core/pages/center-settings/club-center-settings.vue'
      ),
  },
  {
    path: 'option-groups',
    name: 'admin-option-groups',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.option_groups], // TODO: Change the permissions
    },
    component: () =>
      import(
        /* webpackChunkName: "admin-option-groups" */ '@core/pages/option-groups/option-groups.vue'
      ),
  },
  {
    path: 'profiles',
    name: 'admin-profiles',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.profiles],
    },
    component: () =>
      import(
        /* webpackChunkName: "admin-profiles" */ '@core/pages/profile-table/profile-table.vue'
      ),
  },
  {
    path: 'media',
    name: 'admin-media-files',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.media],
    },
    component: () =>
      import(/* webpackChunkName: "admin-media" */ '@core/pages/media-file/media-file.vue'),
  },
];

export default routes;
